import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PhoneCall, PhoneOff } from "lucide-react";
import { RIDE_PENDING_MS, rideCallStore } from "@/lib/rideCallStore";

// Gate 3.4 · incoming ride call shown on any page while the trip page is not open.
export function GlobalRideCallBanner() {
  const navigate = useNavigate();
  const [call, setCall] = useState(() => rideCallStore.current());
  useEffect(() => rideCallStore.subscribe(() => setCall(rideCallStore.current())), []);
  useEffect(() => {
    if (!call) return undefined;
    const t = setTimeout(() => rideCallStore.clear(call.rideId, call.callId), Math.max(0, RIDE_PENDING_MS - (Date.now() - call.at)));
    return () => clearTimeout(t);
  }, [call]);
  if (!call) return null;

  const answer = () => { if (rideCallStore.markAnswer(call.rideId, call.callId)) navigate(`/ride/${call.rideId}`); };
  const decline = () => {
    rideCallStore.send({ type: "ride_webrtc", ride_id: call.rideId, call_id: call.callId, signal: { kind: "decline" } });
    rideCallStore.clear(call.rideId, call.callId);
  };
  return (
    <div role="alertdialog" aria-label="Incoming ride call" data-testid="global-ride-call-banner"
         className="fixed top-3 left-1/2 -translate-x-1/2 z-[9999] w-[min(92vw,420px)] rounded-2xl bg-slate-900 text-white shadow-2xl ring-1 ring-emerald-400/40 px-4 py-3 flex items-center gap-3">
      <span className="w-10 h-10 shrink-0 rounded-full bg-emerald-500 grid place-items-center animate-pulse"><PhoneCall size={18} /></span>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-bold" data-testid="global-ride-call-title">Incoming ride call</div>
        <div className="text-xs text-white/70 truncate" data-testid="global-ride-call-trip">Trip {call.rideId.slice(-6)} · in-app audio</div>
      </div>
      <button onClick={decline} data-testid="global-ride-call-decline" aria-label="Decline"
              className="w-10 h-10 rounded-full bg-rose-600 hover:bg-rose-700 grid place-items-center transition-colors"><PhoneOff size={16} /></button>
      <button onClick={answer} data-testid="global-ride-call-answer"
              className="h-10 px-4 rounded-full bg-emerald-500 hover:bg-emerald-600 text-sm font-bold transition-colors">Answer</button>
    </div>
  );
}
